export const initialTask = {
  assignedTo: [],
  taskStatus: [],
  scheduleStatus: [],
  dueDate: null,
}